import { useEffect, useRef, useState } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet, useLocation } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";
import { FcAddImage } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";

const EditHotelElementor = () => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  const location = useLocation();
  const { propertyid } = location.state || {};
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [indiaStates, setIndiaStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [propertyname, setpropertyname] = useState("");
  const [description, setDescription] = useState("");
  // hotelInfo (table: hotelInfo)
  const [content1, setContent1] = useState("");
  const [content2, setContent2] = useState("");
  const [title1, setTitle1] = useState("");
  const [content3, setContent3] = useState("");
  const [title2, setTitle2] = useState("");
  const [content4, setContent4] = useState("");
  const [seasonType, setSeasonType] = useState("");
  const [locationCity, setLocationCity] = useState("");
  useEffect(() => {
    // Load world.json from public folder
    fetch("/world.json")
      .then((res) => res.json())
      .then((data) => {
        const india = data.find((country) => country.name === "India");
        if (india) {
          setIndiaStates(india.states);
        }
      })
      .catch((err) => console.error("Error loading world.json:", err));
  }, []);
  const [propertyThumbnail, setPropertyThumbnail] = useState(null);

  const handlepropertyThumbnail = (event) => {
    const file = event.target.files[0];
    if (file) {
      const mapUrl = URL.createObjectURL(file);
      setPropertyThumbnail(mapUrl);
    }
  };

  //   const handleStateChange = (e) => {
  //     const stateName = e.target.value;
  //     setSelectedState(stateName);

  //     if (stateName.toLowerCase() === "goa") {
  //       const goaCities = [
  //         "Aldona",
  //         "Arambol",
  //         "Baga",
  //         "Bambolim",
  //         "Bandora",
  //         "Benaulim",
  //         "Calangute",
  //         "Candolim",
  //         "Carapur",
  //         "Cavelossim",
  //         "Chicalim",
  //         "Chinchinim",
  //         "Colovale",
  //         "Colva",
  //         "Cortalim",
  //         "Cuncolim",
  //         "Curchorem",
  //         "Curti",
  //         "Davorlim",
  //         "Dicholi",
  //         "Goa Velha",
  //         "Guirim",
  //         "Jua",
  //         "Kankon",
  //         "Madgaon",
  //         "Мариса",
  //         "Morjim",
  //         "Mormugao",
  //         "Navelim",
  //         "North Goa",
  //         "Palle",
  //         "Panaji",
  //         "Pernem",
  //         "Ponda",
  //         "Quepem",
  //         "Queula",
  //         "Raia",
  //         "Saligao",
  //         "Sancoale",
  //         "Sanguem",
  //         "Sanquelim",
  //         "Sanvordem",
  //         "Serula",
  //         "Solim",
  //         "South Goa",
  //         "Taleigao",
  //         "Vagator",
  //         "Valpoy",
  //         "Varca",
  //         "Vasco da Gama",
  //         // Extra villages
  //         "Anjuna",
  //         "Arpora",
  //         "Assagao",
  //         "Parra",
  //         "Siolim",
  //         "Reis Magos",
  //         "Nerul",
  //       ];

  //       // Convert to {id, name} objects since your city dropdown expects that
  //       setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
  //     } else {
  //       const stateObj = indiaStates.find((s) => s.name === stateName);
  //       setCities(stateObj ? stateObj.cities : []);
  //     }
  //   };
  // Add this useEffect after your existing useEffects

  const [citiesLoading, setCitiesLoading] = useState(false);

  // Update handleStateChange
  const handleStateChange = async (e) => {
    const stateName = e.target.value;
    setSelectedState(stateName);
    setLocationCity("");
    setCitiesLoading(true);

    if (stateName.toLowerCase() === "goa") {
      const goaCities = [
        "Aldona",
        "Arambol",
        "Baga",
        "Bambolim",
        "Bandora",
        "Benaulim",
        "Calangute",
        "Candolim",
        "Carapur",
        "Cavelossim",
        "Chicalim",
        "Chinchinim",
        "Colovale",
        "Colva",
        "Cortalim",
        "Cuncolim",
        "Curchorem",
        "Curti",
        "Davorlim",
        "Dicholi",
        "Goa Velha",
        "Guirim",
        "Jua",
        "Kankon",
        "Madgaon",
        "Мариса",
        "Morjim",
        "Mormugao",
        "Navelim",
        "North Goa",
        "Palle",
        "Panaji",
        "Pernem",
        "Ponda",
        "Quepem",
        "Queula",
        "Raia",
        "Saligao",
        "Sancoale",
        "Sanguem",
        "Sanquelim",
        "Sanvordem",
        "Serula",
        "Solim",
        "South Goa",
        "Taleigao",
        "Vagator",
        "Valpoy",
        "Varca",
        "Vasco da Gama",
        // Extra villages
        "Anjuna",
        "Arpora",
        "Assagao",
        "Parra",
        "Siolim",
        "Reis Magos",
        "Nerul",
      ];
      setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
      setCitiesLoading(false);
    } else if (stateName.toLowerCase() === "karnataka") {
      const karnatakaCities = [
        // Extra villages

        // Added cities
        "Afzalpur",
        "Ajjampur",
        "Aland",
        "Alnavar",
        "lark",
        "Alur",
        "Anekal",
        "Ankola",
        "Annigeri",
        "Arkalgud",
        "Arsikere",
        "Athni",
        "Aurad",
        "Badami",
        "Bagalkot",
        "Bagepalli",
        "Bail-Hongal",
        "Ballari",
        "Banavar",
        "Bangarapet",
        "Bannur",
        "Bantval",
        "Basavakalyan",
        "Basavana Bagevadi",
        "Belagavi",
        "Belluru",
        "Beltangadi",
        "Belur",
        "Bengaluru",
        "Bengaluru Rural",
        "Bengaluru Urban",
        "Bhadravati",
        "Bhalki",
        "Bhatkal",
        "Bidar",
        "Bilgi",
        "Birur",
        "Byadgi",
        "Byndoor",
        "Canacona",
        "Challakere",
        "Chamrajnagar",
        "Channagiri",
        "Channapatna",
        "Channarayapatna",
        "Chik Ballapur",
        "Chikkaballapur",
        "Chikkamagaluru",
        "Chiknayakanhalli",
        "Chikodi",
        "Chincholi",
        "Chintamani",
        "Chitapur",
        "Chitradurga",
        "Closepet",
        "Coondapoor",
        "Coorg",
        "Dakshina Kannada",
        "Dandeli",
        "Davanagere",
        "Devanhalli",
        "Dharwad",
        "Dod Ballapur",
        "French Rocks",
        "Gadag",
        "Gadag-Betageri",
        "Gajendragarh",
        "Gangawati",
        "Gangolli",
        "Gokak",
        "Gokarna",
        "Goribidnur",
        "Gorur",
        "Gubbi",
        "Gudibanda",
        "Guledagudda",
        "Gundlupet",
        "Gurmatkal",
        "Hadagalli",
        "Haliyal",
        "Hampi",
        "Hangal",
        "Harihar",
        "Harpanahalli",
        "Hassan",
        "Haveri",
        "Heggadadevankote",
        "Hirekerur",
        "Hiriyur",
        "Holalkere",
        "Hole Narsipur",
        "Homnabad",
        "Honavar",
        "Honnali",
        "Hosanagara",
        "Hosangadi",
        "Hosdurga",
        "Hoskote",
        "Hospet",
        "Hubballi",
        "Hukeri",
        "Hungund",
        "Hunsur",
        "Ilkal",
        "Indi",
        "Jagalur",
        "Jamkhandi",
        "Jevargi",
        "Kabini",
        "Kadur",
        "Kalaburgi",
        "Kalghatgi",
        "Kampli",
        "Kankanhalli",
        "Karkala",
        "Karwar",
        "Kavalur",
        "Kerur",
        "Khanapur",
        "Kodagu",
        "Kodigenahalli",
        "Kodlipet",
        "Kolar",
        "Kollegal",
        "Konanur",
        "Konnur",
        "Koppa",
        "Koppal",
        "Koratagere",
        "Kotturu",
        "Krishnarajpet",
        "Kudachi",
        "Kudligi",
        "Kumsi",
        "Kumta",
        "Kundgol",
        "Kunigal",
        "Kurgunta",
        "Kushalnagar",
        "Kushtagi",
        "Lakshmeshwar",
        "Lingsugur",
        "Londa",
        "Machare",
        "Maddagiri",
        "Maddur",
        "Madikeri",
        "Magadi",
        "Mahalingpur",
        "Malavalli",
        "Malpe",
        "Malur",
        "Mandya",
        "Mangaluru",
        "Manipal",
        "Manvi",
        "Mayakonda",
        "Melukote",
        "Mudbidri",
        "Muddebihal",
        "Mudgal",
        "Mudgere",
        "Mudhol",
        "Mulbagal",
        "Mulgund",
        "Mulki",
        "Mundargi",
        "Mundgod",
        "Munirabad",
        "Murudeshwara",
        "Mysuru",
        "Nagamangala",
        "Nanjangud",
        "Narasimharajapura",
        "Naregal",
        "Nargund",
        "Navalgund",
        "Nelamangala",
        "Nyamti",
        "Pangala",
        "Pavugada",
        "Piriyapatna",
        "Ponnampet",
        "Puttur",
        "Rabkavi",
        "Raichur",
        "Ramanagara",
        "Ranibennur",
        "Raybag",
        "Robertsonpet",
        "Ron",
        "Sadalgi",
        "Sagar",
        "Sakleshpur",
        "Sandur",
        "Sanivarsante",
        "Sankeshwar",
        "Sargur",
        "Saundatti",
        "Savanur",
        "Seram",
        "Shahabad",
        "Shahpur",
        "Shiggaon",
        "Shikarpur",
        "Shimoga",
        "Shirhatti",
        "Shorapur",
        "Shrirangapattana",
        "Siddapur",
        "Sidlaghatta",
        "Sindgi",
        "Sindhnur",
        "Sira",
        "Sirsi",
        "Siruguppa",
        "Someshwar",
        "Somvarpet",
        "Sorab",
        "Sravana Belgola",
        "Sringeri",
        "Srinivaspur",
        "Sulya",
        "Suntikoppa",
        "Talikota",
        "Tarikere",
        "Tekkalakote",
        "Terdal",
        "Tiptur",
        "Tirthahalli",
        "Tirumakudal Narsipur",
        "Tumakuru",
        "Turuvekere",
        "Udupi",
        "Ullal",
        "Uttar Kannada",
        "Vadigenhalli",
        "Vijayapura",
        "Virarajendrapet",
        "Wadi",
        "Yadgir",
        "Yelahanka",
        "Yelandur",
        "Yelbarga",
        "Yellapur",
      ];
      setCities(
        karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
      );
      setCitiesLoading(false);
    } else if (stateName.toLowerCase() === "kerala") {
      const keralaCities = [
        "Adoor",
        "Alappuzha",
        "Alleppey",
        "Aluva",
        "Alwaye",
        "Angamali",
        "Aroor",
        "Arukutti",
        "Attingal",
        "Avanoor",
        "Azhikkal",
        "Beypore",
        "Changanacheri",
        "Chelakara",
        "Chengannur",
        "Cherpulassery",
        "Cherthala",
        "Chetwayi",
        "Chittur",
        "Cochin",
        "Dharmadom",
        "Edakkulam",
        "Elur",
        "Erattupetta",
        "Ernakulam",
        "Ferokh",
        "Guruvayur",
        "Idukki",
        "Iringal",
        "Irinjalakuda",
        "Kadakkavoor",
        "Kalamassery",
        "Kalavoor",
        "Kalpetta",
        "Kanhangad",
        "Kannavam",
        "Kannur",
        "Kasaragod",
        "Kattanam",
        "Kayankulam",
        "Kizhake Chalakudi",
        "Kochi",
        "Kodungallur",
        "Kollam",
        "Kotamangalam",
        "Kottayam",
        "Kovalam",
        "Kozhikode",
        "Kumbalam",
        "Kunnamangalam",
        "Kunnamkulam",
        "Kunnumma",
        "Kutiatodu",
        "Kuttampuzha",
        "Lalam",
        "Mahe",
        "Malappuram",
        "Manjeri",
        "Manjeshwaram",
        "Mannarakkat",
        "Marayur",
        "Mattanur",
        "Mavelikara",
        "Mavoor",
        "Muluppilagadu",
        "Munnar",
        "Muvattupula",
        "Muvattupuzha",
        "Nadapuram",
        "Naduvannur",
        "Nedumangad",
        "Neyyattinkara",
        "Nileshwar",
        "Ottappalam",
        "Palackattumala",
        "Palakkad district",
        "Palghat",
        "Panamaram",
        "Pappinissheri",
        "Paravur Tekkumbhagam",
        "Pariyapuram",
        "Pathanamthitta",
        "Pattanamtitta",
        "Payyanur",
        "Perinthalmanna",
        "Perumbavoor",
        "Perumpavur",
        "Perya",
        "Piravam",
        "Ponnani",
        "Ponmana",
        "Punalur",
        "Punnayur",
        "Ramamangalam",
        "Shertallai",
        "Shoranur",
        "Taliparamba",
        "Thalassery",
        "Thalikulam",
        "Thanniyam",
        "Thekkady",
        "Thiruvananthapuram",
        "Thrissur",
        "Tirur",
        "Tiruvalla",
        "Vaikam",
        "Varkala",
        "Vatakara",
        "Vayalar",
        "Vettur",
        "Wayanad",
      ];

      setCities(keralaCities.map((city, idx) => ({ id: idx + 1, name: city })));
      setCitiesLoading(false);
    } else if (stateName.toLowerCase() === "tamil nadu") {
      const tamilnaduCities = [
        // Tamil Nadu cities
        "Aambur",
        "Ariyalur",
        "Arakkonam",
        "Arani",
        "Attur",
        "Avadi",
        "Batlagundu",
        "Chengalpattu",
        "Chennai",
        "Chidambaram",
        "Coimbatore",
        "Courtallam",
        "Cuddalore",
        "Coonoor",
        "Dharapuram",
        "Dharmapuri",
        "Dindigul",
        "Erode",
        "Gobichettipalayam",
        "Gudalur",
        "Gudiyatham",
        "Hosur",
        "Jayankondam",
        "Kallakurichi",
        "Kanchipuram",
        "Kanyakumari",
        "Karaikudi",
        "Karur",
        "Kodaikanal",
        "Kovilpatti",
        "Krishnagiri",
        "Kumbakonam",
        "Madurai",
        "Manapparai",
        "Mahabalipuram",
        "Mayiladuthurai",
        "Mettupalayam",
        "Namakkal",
        "Nagapattinam",
        "Nagercoil",
        "Ooty",
        "Palani",
        "Pallavaram",
        "Pattukkottai",
        "Perambalur",
        "Pollachi",
        "Poonamallee",
        "Pudukkottai",
        "Rajapalayam",
        "Ramanathapuram",
        "Ranipet",
        "Salem",
        "Sankagiri",
        "Sivaganga",
        "Sivakasi",
        "Tambaram",
        "Tenkasi",
        "Thanjavur",
        "Theni",
        "Thiruvallur",
        "Thiruvarur",
        "Thoothukudi",
        "Tindivanam",
        "Tiruchendur",
        "Tiruchengode",
        "Tiruchirappalli",
        "Tirunelveli",
        "Tirupathur",
        "Tiruppur",
        "Tiruvannamalai",
        "Udagamandalam",
        "Udumalpet",
        "Usilampatti",
        "Vaniyambadi",
        "Vellore",
        "Villupuram",
        "Virudhunagar",
      ];

      setCities(
        tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
      );
      setCitiesLoading(false);
    } else {
      const stateObj = indiaStates.find((s) => s.name === stateName);
      setCities(stateObj ? stateObj.cities : []);
      setCitiesLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const CustomLeftArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const MAX_CARDS = 5;

  const [selectedImages, setSelectedImages] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...selectedImages];
      updatedImages[index] = imageurl;
      setSelectedImages(updatedImages);
    }
  };

  const [uploadedMap, setUploadedMap] = useState(null);

  const handleMapUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const mapUrl = URL.createObjectURL(file);
      setUploadedMap(mapUrl);
    }
  };

  const TailoredExpCarousel = [
    {
      img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/77613/villa-barbados-caribbean-luxury-the-great-house-boat_FullL.jpg?v=302558110212",
      title: "For Adventure Seekers",
      content:
        "Experience the thrill of Goa with our adventure package! Enjoy cozy stays, a hearty breakfast, and activities like water sports, trekking, and more.",
    },
    {
      img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/66699/villa-barbados-caribbean-luxury-the-great-house-ext-9_FullL.jpg?v=302558110212",
      title: "For Leisure Lovers",
      content:
        "Unwind with our leisure package in Goa. Relax in serene stays, savor a delicious breakfast, and enjoy peaceful beaches, spa sessions, and local attractions.",
    },
  ];

  const responsive_TailoredExpCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_BannerCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1.5,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1.5,
      partialVisibilityGutter: 10,
    },
  };

  const [showDots, setShowDots] = useState(false);

  useEffect(() => {
    const updateDotsVisibility = () => {
      setShowDots(window.innerWidth < 768);
    };

    updateDotsVisibility();
    window.addEventListener("resize", updateDotsVisibility);
    return () => window.removeEventListener("resize", updateDotsVisibility);
  }, []);

  const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const carouselRef = useRef(null);

  const handlePrevSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.previous();
    }
  };

  const handleNextSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const [, setIsOpen_dropdownExp] = useState(false);

  const dropdownRef_dropdownExp = useRef(null);

  useEffect(() => {
    const handleClickOutside_dropdownExp = (event) => {
      if (
        dropdownRef_dropdownExp.current &&
        !dropdownRef_dropdownExp.current.contains(event.target)
      ) {
        setIsOpen_dropdownExp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside_dropdownExp);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
  }, []);
  // const [tailoredExpData, setTailoredExpData] = useState([
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  //   { img: null, title: "", content: "" },
  // ]);
  const [tailoredExpData, setTailoredExpData] = useState(
    Array.from({ length: 10 }, () => ({
      img: null,
      title: "",
      content: "",
      link: "",
    })),
  );

  const MAX_CARDS_Exp = tailoredExpData.length;

  //   const handleSaveHotel = async () => {
  //     try {
  //       setLoading(true);

  //       const formData = new FormData();

  //       // property fields
  //       [
  //         "propertyname",
  //         "description",
  //         "propertycode",
  //         "currentprice",
  //         "defaultprice",
  //         "deposit",
  //         "maxadult",
  //         "maxchild",
  //         "maxbed",
  //         "maxbath",
  //         "maplink",
  //         "youtubelink",
  //         "location",
  //         "propertytype",
  //         "destination",
  //         "seasonType",
  //         "propertyowner",
  //       ].forEach((name) => {
  //         const el = document.querySelector(`[name="${name}"]`);
  //         if (el) formData.append(name, el.value);
  //       });

  //       // hotel info images
  //       for (let i = 0; i < selectedImages.length; i++) {
  //         if (selectedImages[i]) {
  //           formData.append(
  //             `banner${i + 1}`,
  //             await urlToFile(selectedImages[i], `banner${i + 1}.jpg`)
  //           );
  //         }
  //       }

  //       if (uploadedMap) {
  //         formData.append(
  //           "portraitimg",
  //           await urlToFile(uploadedMap, "portraitimg.jpg")
  //         );
  //       }

  //       // hotel content
  //       formData.append(
  //         "content1",
  //         document.querySelector('textarea[name="content1"]')?.value || ""
  //       );
  //       formData.append(
  //         "content2",
  //         document.querySelector('textarea[name="content2"]')?.value || ""
  //       );
  //       formData.append(
  //         "title1",
  //         document.querySelector('input[name="title1"]')?.value || ""
  //       );
  //       formData.append(
  //         "content3",
  //         document.querySelector('textarea[name="content3"]')?.value || ""
  //       );
  //       formData.append(
  //         "title2",
  //         document.querySelector('input[name="title2"]')?.value || ""
  //       );
  //       formData.append(
  //         "content4",
  //         document.querySelector('textarea[name="content4"]')?.value || ""
  //       );

  //       // experiences
  //       for (let i = 0; i < tailoredExpData.length; i++) {
  //         const exp = tailoredExpData[i];
  //         if (exp.img)
  //           formData.append(
  //             `expimghotel${i + 1}`,
  //             await urlToFile(exp.img, `expimghotel${i + 1}.jpg`)
  //           );
  //         formData.append(`exptitlehotel${i + 1}`, exp.title || "");
  //         formData.append(`expconhotel${i + 1}`, exp.content || "");
  //       }

  //       // send
  //       const res = await fetch(
  //         "https://demo.zorbastays.com/web-backend/createHotelProperty",
  //         {
  //           method: "POST",
  //           body: formData,
  //         }
  //       );

  //       const data = await res.json();
  //       if (data.success) {
  //         toast.success("Hotel property added successfully 🎉");
  //         setTimeout(() => navigate("/Properties"), 1000);
  //       } else {
  //         toast.error("Failed to save hotel property");
  //       }
  //     } catch (err) {
  //       console.error("Error:", err);
  //       toast.error("Something went wrong");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const handleUpdateHotel = async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("propertyname", propertyname);
      formData.append("description", description); // use state!
      formData.append(
        "propertycode",
        document.querySelector('[name="propertycode"]')?.value || "",
      );
      formData.append(
        "currentprice",
        document.querySelector('[name="currentprice"]')?.value || "",
      );
      formData.append(
        "defaultprice",
        document.querySelector('[name="defaultprice"]')?.value || "",
      );
      formData.append(
        "deposit",
        document.querySelector('[name="deposit"]')?.value || "",
      );
      formData.append(
        "maxadult",
        document.querySelector('[name="maxadult"]')?.value || "",
      );
      formData.append(
        "maxchild",
        document.querySelector('[name="maxchild"]')?.value || "",
      );
      formData.append(
        "maxbed",
        document.querySelector('[name="maxbed"]')?.value || "",
      );
      formData.append(
        "maxbath",
        document.querySelector('[name="maxbath"]')?.value || "",
      );
      formData.append(
        "maplink",
        document.querySelector('[name="maplink"]')?.value || "",
      );
      formData.append(
        "youtubelink",
        document.querySelector('[name="youtubelink"]')?.value || "",
      );
      formData.append("location", locationCity || "");
      formData.append(
        "propertytype",
        document.querySelector('[name="propertytype"]')?.value || "",
      );
      // formData.append("destination", document.querySelector('[name="destination"]')?.value || "");
      formData.append("destination", selectedState || "");
      formData.append(
        "seasonType",
        document.querySelector('[name="seasonType"]')?.value || "",
      );
      formData.append(
        "propertyowner",
        document.querySelector('[name="propertyowner"]')?.value || "",
      );
      formData.append(
        "propertybrochure",
        document.querySelector('[name="propertybrochure"]')?.value || "",
      );

      // ✅ Banners: upload only new (blob/data) images
      for (let i = 0; i < selectedImages.length; i++) {
        const img = selectedImages[i];
        if (img && (img.startsWith("blob:") || img.startsWith("data:"))) {
          formData.append(
            `banner${i + 1}`,
            await urlToFile(img, `banner${i + 1}.jpg`),
          );
        }
      }
      // ✅ Thumbnail Image (only send if it's newly uploaded blob)
      if (
        propertyThumbnail &&
        (propertyThumbnail.startsWith("blob:") ||
          propertyThumbnail.startsWith("data:"))
      ) {
        formData.append(
          "thumbnailimg",
          await urlToFile(propertyThumbnail, "thumbnailimg.jpg"),
        );
      }

      // ✅ Portrait
      if (
        uploadedMap &&
        (uploadedMap.startsWith("blob:") || uploadedMap.startsWith("data:"))
      ) {
        formData.append(
          "portraitimg",
          await urlToFile(uploadedMap, "portraitimg.jpg"),
        );
      }

      // ✅ Hotel content (main text sections)
      [
        "content1",
        "content2",
        "title1",
        "content3",
        "title2",
        "content4",
      ].forEach((name) => {
        const el =
          document.querySelector(`textarea[name="${name}"]`) ||
          document.querySelector(`input[name="${name}"]`);
        if (el) formData.append(name, el.value);
      });

      // ✅ Experience sections (text + possibly new images)
      for (let i = 0; i < tailoredExpData.length; i++) {
        const exp = tailoredExpData[i];
        if (
          exp.img &&
          (exp.img.startsWith("blob:") || exp.img.startsWith("data:"))
        ) {
          formData.append(
            `expimghotel${i + 1}`,
            await urlToFile(exp.img, `expimghotel${i + 1}.jpg`),
          );
        }
        formData.append(`exptitlehotel${i + 1}`, exp.title || "");
        formData.append(`expconhotel${i + 1}`, exp.content || "");
        formData.append(`explinkhotel${i + 1}`, exp.link || "");
      }

      // ✅ Send PUT request
      const res = await fetch(
        `https://demo.zorbastays.com/web-backend/updateHotelProperty/${propertyid}`,
        {
          method: "PUT",
          body: formData,
        },
      );

      const data = await res.json();
      if (data.success) {
        toast.success("Hotel property updated successfully 🎉");
        setTimeout(() => navigate("/Properties"), 1000);
      } else {
        toast.error(data.message || "Failed to update hotel property");
      }
    } catch (err) {
      console.error("Update Error:", err);
      toast.error("Something went wrong while updating");
    } finally {
      setLoading(false);
    }
  };

  const urlToFile = async (url, filename) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  };

  useEffect(() => {
    if (!propertyid) return;

    const fetchHotel = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://demo.zorbastays.com/web-backend/hotel/${propertyid}`,
        );
        const data = await res.json();
        console.log("Hotel API response:", data);

        if (!data.success) {
          toast.error("No hotel data found");
          return;
        }

        const hotelInfo = data.hotelInfo || {};
        const property = data.property || {};

        //  fill property fields
        setpropertyname(property.propertyname || "");
        setDescription(property.description || "");
        setSelectedState(property.destination || "");
        setLocationCity(property.location || "");
        // 🔹 Auto-load cities for fetched destination
        if (property.destination) {
          const stateName = property.destination;
          if (stateName.toLowerCase() === "goa") {
            const goaCities = [
              "Aldona",
              "Arambol",
              "Baga",
              "Bambolim",
              "Bandora",
              "Benaulim",
              "Calangute",
              "Candolim",
              "Carapur",
              "Cavelossim",
              "Chicalim",
              "Chinchinim",
              "Colovale",
              "Colva",
              "Cortalim",
              "Cuncolim",
              "Curchorem",
              "Curti",
              "Davorlim",
              "Dicholi",
              "Goa Velha",
              "Guirim",
              "Jua",
              "Kankon",
              "Madgaon",
              "Мариса",
              "Morjim",
              "Mormugao",
              "Navelim",
              "North Goa",
              "Palle",
              "Panaji",
              "Pernem",
              "Ponda",
              "Quepem",
              "Queula",
              "Raia",
              "Saligao",
              "Sancoale",
              "Sanguem",
              "Sanquelim",
              "Sanvordem",
              "Serula",
              "Solim",
              "South Goa",
              "Taleigao",
              "Vagator",
              "Valpoy",
              "Varca",
              "Vasco da Gama",
              "Anjuna",
              "Arpora",
              "Assagao",
              "Parra",
              "Siolim",
              "Reis Magos",
              "Nerul",
            ];
            setCities(
              goaCities.map((city, idx) => ({ id: idx + 1, name: city })),
            );
          } else if (stateName.toLowerCase() === "karnataka") {
            const karnatakaCities = [
              // Extra villages

              // Added cities
              "Afzalpur",
              "Ajjampur",
              "Aland",
              "Alnavar",
              "lark",
              "Alur",
              "Anekal",
              "Ankola",
              "Annigeri",
              "Arkalgud",
              "Arsikere",
              "Athni",
              "Aurad",
              "Badami",
              "Bagalkot",
              "Bagepalli",
              "Bail-Hongal",
              "Ballari",
              "Banavar",
              "Bangarapet",
              "Bannur",
              "Bantval",
              "Basavakalyan",
              "Basavana Bagevadi",
              "Belagavi",
              "Belluru",
              "Beltangadi",
              "Belur",
              "Bengaluru",
              "Bengaluru Rural",
              "Bengaluru Urban",
              "Bhadravati",
              "Bhalki",
              "Bhatkal",
              "Bidar",
              "Bilgi",
              "Birur",
              "Byadgi",
              "Byndoor",
              "Canacona",
              "Challakere",
              "Chamrajnagar",
              "Channagiri",
              "Channapatna",
              "Channarayapatna",
              "Chik Ballapur",
              "Chikkaballapur",
              "Chikkamagaluru",
              "Chiknayakanhalli",
              "Chikodi",
              "Chincholi",
              "Chintamani",
              "Chitapur",
              "Chitradurga",
              "Closepet",
              "Coondapoor",
              "Coorg",
              "Dakshina Kannada",
              "Dandeli",
              "Davanagere",
              "Devanhalli",
              "Dharwad",
              "Dod Ballapur",
              "French Rocks",
              "Gadag",
              "Gadag-Betageri",
              "Gajendragarh",
              "Gangawati",
              "Gangolli",
              "Gokak",
              "Gokarna",
              "Goribidnur",
              "Gorur",
              "Gubbi",
              "Gudibanda",
              "Guledagudda",
              "Gundlupet",
              "Gurmatkal",
              "Hadagalli",
              "Haliyal",
              "Hampi",
              "Hangal",
              "Harihar",
              "Harpanahalli",
              "Hassan",
              "Haveri",
              "Heggadadevankote",
              "Hirekerur",
              "Hiriyur",
              "Holalkere",
              "Hole Narsipur",
              "Homnabad",
              "Honavar",
              "Honnali",
              "Hosanagara",
              "Hosangadi",
              "Hosdurga",
              "Hoskote",
              "Hospet",
              "Hubballi",
              "Hukeri",
              "Hungund",
              "Hunsur",
              "Ilkal",
              "Indi",
              "Jagalur",
              "Jamkhandi",
              "Jevargi",
              "Kabini",
              "Kadur",
              "Kalaburgi",
              "Kalghatgi",
              "Kampli",
              "Kankanhalli",
              "Karkala",
              "Karwar",
              "Kavalur",
              "Kerur",
              "Khanapur",
              "Kodagu",
              "Kodigenahalli",
              "Kodlipet",
              "Kolar",
              "Kollegal",
              "Konanur",
              "Konnur",
              "Koppa",
              "Koppal",
              "Koratagere",
              "Kotturu",
              "Krishnarajpet",
              "Kudachi",
              "Kudligi",
              "Kumsi",
              "Kumta",
              "Kundgol",
              "Kunigal",
              "Kurgunta",
              "Kushalnagar",
              "Kushtagi",
              "Lakshmeshwar",
              "Lingsugur",
              "Londa",
              "Machare",
              "Maddagiri",
              "Maddur",
              "Madikeri",
              "Magadi",
              "Mahalingpur",
              "Malavalli",
              "Malpe",
              "Malur",
              "Mandya",
              "Mangaluru",
              "Manipal",
              "Manvi",
              "Mayakonda",
              "Melukote",
              "Mudbidri",
              "Muddebihal",
              "Mudgal",
              "Mudgere",
              "Mudhol",
              "Mulbagal",
              "Mulgund",
              "Mulki",
              "Mundargi",
              "Mundgod",
              "Munirabad",
              "Murudeshwara",
              "Mysuru",
              "Nagamangala",
              "Nanjangud",
              "Narasimharajapura",
              "Naregal",
              "Nargund",
              "Navalgund",
              "Nelamangala",
              "Nyamti",
              "Pangala",
              "Pavugada",
              "Piriyapatna",
              "Ponnampet",
              "Puttur",
              "Rabkavi",
              "Raichur",
              "Ramanagara",
              "Ranibennur",
              "Raybag",
              "Robertsonpet",
              "Ron",
              "Sadalgi",
              "Sagar",
              "Sakleshpur",
              "Sandur",
              "Sanivarsante",
              "Sankeshwar",
              "Sargur",
              "Saundatti",
              "Savanur",
              "Seram",
              "Shahabad",
              "Shahpur",
              "Shiggaon",
              "Shikarpur",
              "Shimoga",
              "Shirhatti",
              "Shorapur",
              "Shrirangapattana",
              "Siddapur",
              "Sidlaghatta",
              "Sindgi",
              "Sindhnur",
              "Sira",
              "Sirsi",
              "Siruguppa",
              "Someshwar",
              "Somvarpet",
              "Sorab",
              "Sravana Belgola",
              "Sringeri",
              "Srinivaspur",
              "Sulya",
              "Suntikoppa",
              "Talikota",
              "Tarikere",
              "Tekkalakote",
              "Terdal",
              "Tiptur",
              "Tirthahalli",
              "Tirumakudal Narsipur",
              "Tumakuru",
              "Turuvekere",
              "Udupi",
              "Ullal",
              "Uttar Kannada",
              "Vadigenhalli",
              "Vijayapura",
              "Virarajendrapet",
              "Wadi",
              "Yadgir",
              "Yelahanka",
              "Yelandur",
              "Yelbarga",
              "Yellapur",
            ];
            setCities(
              karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
            );
          } else if (stateName.toLowerCase() === "kerala") {
            const keralaCities = [
              "Adoor",
              "Alappuzha",
              "Alleppey",
              "Aluva",
              "Alwaye",
              "Angamali",
              "Aroor",
              "Arukutti",
              "Attingal",
              "Avanoor",
              "Azhikkal",
              "Beypore",
              "Changanacheri",
              "Chelakara",
              "Chengannur",
              "Cherpulassery",
              "Cherthala",
              "Chetwayi",
              "Chittur",
              "Cochin",
              "Dharmadom",
              "Edakkulam",
              "Elur",
              "Erattupetta",
              "Ernakulam",
              "Ferokh",
              "Guruvayur",
              "Idukki",
              "Iringal",
              "Irinjalakuda",
              "Kadakkavoor",
              "Kalamassery",
              "Kalavoor",
              "Kalpetta",
              "Kanhangad",
              "Kannavam",
              "Kannur",
              "Kasaragod",
              "Kattanam",
              "Kayankulam",
              "Kizhake Chalakudi",
              "Kochi",
              "Kodungallur",
              "Kollam",
              "Kotamangalam",
              "Kottayam",
              "Kovalam",
              "Kozhikode",
              "Kumbalam",
              "Kunnamangalam",
              "Kunnamkulam",
              "Kunnumma",
              "Kutiatodu",
              "Kuttampuzha",
              "Lalam",
              "Mahe",
              "Malappuram",
              "Manjeri",
              "Manjeshwaram",
              "Mannarakkat",
              "Marayur",
              "Mattanur",
              "Mavelikara",
              "Mavoor",
              "Muluppilagadu",
              "Munnar",
              "Muvattupula",
              "Muvattupuzha",
              "Nadapuram",
              "Naduvannur",
              "Nedumangad",
              "Neyyattinkara",
              "Nileshwar",
              "Ottappalam",
              "Palackattumala",
              "Palakkad district",
              "Palghat",
              "Panamaram",
              "Pappinissheri",
              "Paravur Tekkumbhagam",
              "Pariyapuram",
              "Pathanamthitta",
              "Pattanamtitta",
              "Payyanur",
              "Perinthalmanna",
              "Perumbavoor",
              "Perumpavur",
              "Perya",
              "Piravam",
              "Ponnani",
              "Ponmana",
              "Punalur",
              "Punnayur",
              "Ramamangalam",
              "Shertallai",
              "Shoranur",
              "Taliparamba",
              "Thalassery",
              "Thalikulam",
              "Thanniyam",
              "Thekkady",
              "Thiruvananthapuram",
              "Thrissur",
              "Tirur",
              "Tiruvalla",
              "Vaikam",
              "Varkala",
              "Vatakara",
              "Vayalar",
              "Vettur",
              "Wayanad",
            ];
            setCities(
              keralaCities.map((city, idx) => ({ id: idx + 1, name: city })),
            );
          } else if (stateName.toLowerCase() === "tamil nadu") {
            const tamilnaduCities = [
              // Tamil Nadu cities
              "Aambur",
              "Ariyalur",
              "Arakkonam",
              "Arani",
              "Attur",
              "Avadi",
              "Batlagundu",
              "Chengalpattu",
              "Chennai",
              "Chidambaram",
              "Coimbatore",
              "Courtallam",
              "Cuddalore",
              "Coonoor",
              "Dharapuram",
              "Dharmapuri",
              "Dindigul",
              "Erode",
              "Gobichettipalayam",
              "Gudalur",
              "Gudiyatham",
              "Hosur",
              "Jayankondam",
              "Kallakurichi",
              "Kanchipuram",
              "Kanyakumari",
              "Karaikudi",
              "Karur",
              "Kodaikanal",
              "Kovilpatti",
              "Krishnagiri",
              "Kumbakonam",
              "Madurai",
              "Manapparai",
              "Mahabalipuram",
              "Mayiladuthurai",
              "Mettupalayam",
              "Namakkal",
              "Nagapattinam",
              "Nagercoil",
              "Ooty",
              "Palani",
              "Pallavaram",
              "Pattukkottai",
              "Perambalur",
              "Pollachi",
              "Poonamallee",
              "Pudukkottai",
              "Rajapalayam",
              "Ramanathapuram",
              "Ranipet",
              "Salem",
              "Sankagiri",
              "Sivaganga",
              "Sivakasi",
              "Tambaram",
              "Tenkasi",
              "Thanjavur",
              "Theni",
              "Thiruvallur",
              "Thiruvarur",
              "Thoothukudi",
              "Tindivanam",
              "Tiruchendur",
              "Tiruchengode",
              "Tiruchirappalli",
              "Tirunelveli",
              "Tirupathur",
              "Tiruppur",
              "Tiruvannamalai",
              "Udagamandalam",
              "Udumalpet",
              "Usilampatti",
              "Vaniyambadi",
              "Vellore",
              "Villupuram",
              "Virudhunagar",
            ];
            setCities(
              tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
            );
          } else {
            const stateObj = indiaStates.find((s) => s.name === stateName);
            if (stateObj) setCities(stateObj.cities || []);
          }
        }

        document
          .querySelector('[name="propertyowner"]')
          ?.setAttribute("value", property.propertyowner || "");
        document
          .querySelector('[name="propertybrochure"]')
          ?.setAttribute("value", property.propertybrochure || "");
        document
          .querySelector('[name="propertycode"]')
          ?.setAttribute("value", property.propertycode || "");
        document
          .querySelector('[name="currentprice"]')
          ?.setAttribute("value", property.currentprice || "");
        document
          .querySelector('[name="defaultprice"]')
          ?.setAttribute("value", property.defaultprice || "");
        document
          .querySelector('[name="deposit"]')
          ?.setAttribute("value", property.deposit || "");
        document
          .querySelector('[name="maxadult"]')
          ?.setAttribute("value", property.maxadult || "");
        document
          .querySelector('[name="maxchild"]')
          ?.setAttribute("value", property.maxchild || "");
        document
          .querySelector('[name="maxbed"]')
          ?.setAttribute("value", property.maxbed || "");
        document
          .querySelector('[name="maxbath"]')
          ?.setAttribute("value", property.maxbath || "");
        document
          .querySelector('[name="maplink"]')
          ?.setAttribute("value", property.maplink || "");
        document
          .querySelector('[name="youtubelink"]')
          ?.setAttribute("value", property.youtubelink || "");
        document
          .querySelector('[name="seasonType"]')
          ?.setAttribute("value", property.seasonType || "");
        document
          .querySelector('[name="propertytype"]')
          ?.setAttribute("value", property.propertytype || "Hotel");
        document
          .querySelector('[name="destination"]')
          ?.setAttribute("value", property.destination || "");
        document
          .querySelector('[name="location"]')
          ?.setAttribute("value", property.location || "");
        setSeasonType(property.seasonType || "");

        // fill hotelInfo (content/titles)
        setContent1(hotelInfo.content1 || "");
        setContent2(hotelInfo.content2 || "");
        setTitle1(hotelInfo.title1 || "");
        setContent3(hotelInfo.content3 || "");
        setTitle2(hotelInfo.title2 || "");
        setContent4(hotelInfo.content4 || "");

        // banners
        const banners = [
          hotelInfo.banner1,
          hotelInfo.banner2,
          hotelInfo.banner3,
          hotelInfo.banner4,
          hotelInfo.banner5,
        ];
        setSelectedImages((prev) => prev.map((_, i) => banners[i] || null));

        //  map image
        if (hotelInfo.portraitimg) setUploadedMap(hotelInfo.portraitimg);
        // 🔹 Load Thumbnail Image
        if (hotelInfo.thumbnailimg) {
          setPropertyThumbnail(hotelInfo.thumbnailimg);
        }
        //  experience section (up to 10)
        const expData = Array.from({ length: 10 }, (_, i) => ({
          img: hotelInfo[`expimghotel${i + 1}`] || null,
          title: hotelInfo[`exptitlehotel${i + 1}`] || "",
          content: hotelInfo[`expconhotel${i + 1}`] || "",
          link: hotelInfo[`explinkhotel${i + 1}`] || "",
        }));
        setTailoredExpData(expData);
      } catch (err) {
        console.error("Fetch error:", err);
        toast.error("Something went wrong while fetching hotel data");
      } finally {
        setLoading(false);
      }
    };

    fetchHotel();
  }, [propertyid, indiaStates]);
  const handleDeleteHotelImage = async (
    fieldName,
    { isLocalOnly = false, localClear = null } = {},
  ) => {
    if (!window.confirm("Delete this image?")) return;

    if (localClear) localClear();

    if (isLocalOnly) {
      toast.success("Image removed");
      return;
    }

    try {
      await fetch(
        `https://demo.zorbastays.com/web-backend/property/${propertyid}/image`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fieldName, table: "hotelInfo" }),
        },
      );
      toast.success("Image deleted");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete image");
    }
  };
  return (
    <div
      className={`flex bg-[#F8F9FA] transition-all duration-500 ${
        isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
      }`}
    >
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Edit Hotel
            </p>
          </div>
        </div>

        <div className="my-10">
          <div className="">
            <div className="flex justify-between items-center  mt-5">
              <div className="felx flex-col mx-auto">
                {/* goes to table "properties" as "propertyname" */}
                <input
                  type="text"
                  name="propertyname"
                  required
                  maxLength={50}
                  value={propertyname}
                  onChange={(e) => setpropertyname(e.target.value)}
                  className="text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Enter Hotel Name"
                />{" "}
                <p className="text-center text-xs mt-1">
                  {propertyname.length.toString().padStart(2, "0")}/50
                </p>
                {/* goes to table "properties" as "description" */}
                <div className="my-4">
                  <textarea
                    rows="2"
                    name="description"
                    maxLength={100}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Enter Hotel Description..."
                  />
                  <p className="text-center text-xs">
                    {description.length.toString().padStart(2, "0")}/100
                  </p>
                </div>
              </div>

              <div className="max-w-lg">
                <div className="space-y-4">
                  {propertyThumbnail ? (
                    <>
                      <div className="relative">
                        <img
                          src={propertyThumbnail}
                          alt="Uploaded Map"
                          className="h-full max-h-[85vh] aspect-[5/4] w-full object-cover"
                        />

                        <div
                          onClick={() => {
                            const isLocalOnly =
                              !!propertyThumbnail &&
                              (propertyThumbnail.startsWith("blob:") ||
                                propertyThumbnail.startsWith("data:"));
                            handleDeleteHotelImage("thumbnailimg", {
                              isLocalOnly,
                              localClear: () => setPropertyThumbnail(null),
                            });
                          }}
                          className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                        >
                          <MdDelete size={18} />
                        </div>
                      </div>

                      <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace <FcAddImage size={20} />{" "}
                        </div>
                        {/* goes to table "hotelInfo" as portraitimg */}
                        <input
                          type="file"
                          accept="image/*"
                          name="thumbnailimg"
                          onChange={handlepropertyThumbnail}
                          className="hidden aspect-[5/4] w-full"
                        />
                      </label>
                    </>
                  ) : (
                    <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                      <FcAddImage size={50} />
                      <span className="text-sm mt-2">
                        Click to upload Thumbnail image
                      </span>
                      {/* goes to table "hotelInfo" as portraitimg */}
                      <input
                        type="file"
                        name="thumbnailimg"
                        accept="image/*"
                        onChange={handlepropertyThumbnail}
                        className="hidden aspect-[5/4] w-full"
                      />
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Banner carousel */}
            <div className="mt-5 -mx-3">
              {/* goes to table "hotelInfo" as "banner1"....till ..."banner5" */}

              <Carousel
                responsive={responsive_BannerCarousel}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={false}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {selectedImages[index] ? (
                        <>
                          <img
                            src={selectedImages[index]}
                            alt="Img"
                            className="w-full h-full object-cover"
                          />

                          <div
                            onClick={() => {
                              const fieldName = `banner${index + 1}`;
                              const isLocalOnly =
                                !!selectedImages[index] &&
                                (selectedImages[index].startsWith("blob:") ||
                                  selectedImages[index].startsWith("data:"));
                              handleDeleteHotelImage(fieldName, {
                                isLocalOnly,
                                localClear: () =>
                                  setSelectedImages((prev) => {
                                    const u = [...prev];
                                    u[index] = null;
                                    return u;
                                  }),
                              });
                            }}
                            className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                          >
                            <MdDelete size={18} />
                          </div>

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, index)}
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageUpload(e, index)}
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>

          {/* 2 Column grid Img + Content */}

          <div className="grid grid-cols-1 lg:grid-cols-[35%_60%] items-center leading-relaxed gap-5 mt-10">
            <div className="h-full">
              {uploadedMap ? (
                <>
                  <div className="relative">
                    <img
                      src={uploadedMap}
                      alt="Uploaded Map"
                      className="h-full max-h-[85vh] w-full object-cover"
                    />

                    <div
                      onClick={() => {
                        const isLocalOnly =
                          !!uploadedMap &&
                          (uploadedMap.startsWith("blob:") ||
                            uploadedMap.startsWith("data:"));
                        handleDeleteHotelImage("portraitimg", {
                          isLocalOnly,
                          localClear: () => setUploadedMap(null),
                        });
                      }}
                      className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                    >
                      <MdDelete size={18} />
                    </div>
                  </div>

                  <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center">
                      Replace <FcAddImage size={20} />{" "}
                    </div>
                    {/* goes to table "hotelInfo" as portraitimg */}
                    <input
                      type="file"
                      accept="image/*"
                      name="portraitimg"
                      onChange={handleMapUpload}
                      className="hidden"
                    />
                  </label>
                </>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload map image
                  </span>
                  {/* goes to table "hotelInfo" as portraitimg */}
                  <input
                    type="file"
                    name="portraitimg"
                    accept="image/*"
                    onChange={handleMapUpload}
                    className="hidden"
                  />
                </label>
              )}
            </div>

            <div>
              {/* goes to table "hotelInfo" as content1 */}
              <textarea
                rows="2"
                name="content1"
                maxLength={400}
                value={content1}
                onChange={(e) => setContent1(e.target.value)}
                className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Enter Content 1 ..."
              />
              <p className="text-xs">
                {content1.length.toString().padStart(2, "0")}/400
              </p>

              <br />
              {/* goes to table "hotelInfo" as content2 */}
              <textarea
                rows="2"
                name="content2"
                maxLength={400}
                value={content2}
                onChange={(e) => setContent2(e.target.value)}
                className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Enter Contetn 2 ..."
              />
              <p className="text-xs">
                {content2.length.toString().padStart(2, "0")}/400
              </p>

              <br />
              {/* goes to table "hotelInfo" as title1 */}
              <input
                type="text"
                name="title1"
                required
                maxLength={50}
                value={title1}
                onChange={(e) => setTitle1(e.target.value)}
                className="w-full text-2xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Title 1"
              />
              <p className="text-xs mt-1">
                {title1.length.toString().padStart(2, "0")}/50
              </p>

              <br />
              {/* goes to table "hotelInfo" as content3 */}
              <textarea
                rows="2"
                name="content3"
                maxLength={200}
                value={content3}
                onChange={(e) => setContent3(e.target.value)}
                className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Enter Contetn 3 ..."
              />
              <p className="text-xs">
                {content3.length.toString().padStart(2, "0")}/200
              </p>

              <br />
              {/* goes to table "hotelInfo" as title2 */}
              <input
                type="text"
                name="title2"
                required
                maxLength={50}
                value={title2}
                onChange={(e) => setTitle2(e.target.value)}
                className="w-full text-2xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Title 2"
              />
              <p className="text-xs mt-1">
                {title2.length.toString().padStart(2, "0")}/50
              </p>

              <br />
              {/* goes to table "hotelInfo" as content4 */}
              <textarea
                rows="2"
                name="content4"
                maxLength={200}
                value={content4}
                onChange={(e) => setContent4(e.target.value)}
                className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Enter Contetn 4 ..."
              />
              <p className="text-xs">
                {content4.length.toString().padStart(2, "0")}/200
              </p>
            </div>
          </div>

          {/* Other hotels */}
          {/* <div className="mt-10">
            <p
              className="fontPD text-2xl md:text-3xl"
              style={{
                letterSpacing: "1px",
                wordSpacing: "2px",
                lineHeight: 1.5,
              }}
            >
              Other Hotels
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
              <div className="">
                <div className="">
                  {uploadedMap ? (
                    <>
                      <img
                        src={uploadedMap}
                        alt="Uploaded Map"
                        className="h-full w-full object-cover"
                      />

                      <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace Img <FcAddImage size={20} />{" "}
                        </div>
                   
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleMapUpload}
                          className="hidden"
                        />
                      </label>
                    </>
                  ) : (
                    <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                      <FcAddImage size={50} />
                      <span className="text-sm mt-2">
                        Click to upload map image
                      </span>
                     
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleMapUpload}
                        className="hidden"
                      />
                    </label>
                  )}
                </div>

                <div className="">
                  <input
                    type="text"
                    placeholder="Heading 1"
                    maxLength={30}
                    value={locationTagline}
                    onChange={(e) => setLocationTagline(e.target.value)}
                    className="mt-3 w-full text-2xl md:text-3xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{
                      letterSpacing: "1px",
                      wordSpacing: "2px",
                      lineHeight: 1.3,
                    }}
                  />
                  <p className="text-xs mt-1">
                    {locationTagline.length.toString().padStart(2, "0")}/30
                  </p>

                  <br />

                  <textarea
                    rows="3"
                    type="text"
                    placeholder="Description 1..."
                    maxLength={150}
                    value={locationContent}
                    onChange={(e) => setLocationContent(e.target.value)}
                    className="flex mx-auto w-full font-thin text-left text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{ lineHeight: 2 }}
                  />
                  <p className="text-xs block mt-1 text-left">
                    {locationContent.length.toString().padStart(2, "0")}/150
                  </p>
                </div>
              </div>

              <div className="">
                <div className="">
                  {uploadedMap ? (
                    <>
                      <img
                        src={uploadedMap}
                        alt="Uploaded Map"
                        className="h-full w-full object-cover"
                      />

                      <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace Img <FcAddImage size={20} />{" "}
                        </div>
                     
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleMapUpload}
                          className="hidden"
                        />
                      </label>
                    </>
                  ) : (
                    <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                      <FcAddImage size={50} />
                      <span className="text-sm mt-2">
                        Click to upload map image
                      </span>
                
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleMapUpload}
                        className="hidden"
                      />
                    </label>
                  )}
                </div>

                <div className="">
                  <input
                    type="text"
                    placeholder="Heading 2"
                    maxLength={30}
                    value={locationTagline}
                    onChange={(e) => setLocationTagline(e.target.value)}
                    className="mt-3 w-full text-2xl md:text-3xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{
                      letterSpacing: "1px",
                      wordSpacing: "2px",
                      lineHeight: 1.3,
                    }}
                  />
                  <p className="text-xs mt-1">
                    {locationTagline.length.toString().padStart(2, "0")}/30
                  </p>

                  <br />

                  <textarea
                    rows="3"
                    type="text"
                    placeholder="Description 2..."
                    maxLength={150}
                    value={locationContent}
                    onChange={(e) => setLocationContent(e.target.value)}
                    className="flex mx-auto w-full font-thin text-left text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{ lineHeight: 2 }}
                  />
                  <p className="text-xs block mt-1 text-left">
                    {locationContent.length.toString().padStart(2, "0")}/150
                  </p>
                </div>
              </div>

              <div className="">
                <div className="">
                  {uploadedMap ? (
                    <>
                      <img
                        src={uploadedMap}
                        alt="Uploaded Map"
                        className="h-full w-full object-cover"
                      />

                      <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace Img <FcAddImage size={20} />{" "}
                        </div>
                       
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleMapUpload}
                          className="hidden"
                        />
                      </label>
                    </>
                  ) : (
                    <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                      <FcAddImage size={50} />
                      <span className="text-sm mt-2">
                        Click to upload map image
                      </span>
                     
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleMapUpload}
                        className="hidden"
                      />
                    </label>
                  )}
                </div>

                <div className="">
                  <input
                    type="text"
                    placeholder="Heading 3"
                    maxLength={30}
                    value={locationTagline}
                    onChange={(e) => setLocationTagline(e.target.value)}
                    className="mt-3 w-full text-2xl md:text-3xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{
                      letterSpacing: "1px",
                      wordSpacing: "2px",
                      lineHeight: 1.3,
                    }}
                  />
                  <p className="text-xs mt-1">
                    {locationTagline.length.toString().padStart(2, "0")}/30
                  </p>

                  <br />

                  <textarea
                    rows="3"
                    type="text"
                    placeholder="Description 3..."
                    maxLength={150}
                    value={locationContent}
                    onChange={(e) => setLocationContent(e.target.value)}
                    className="flex mx-auto w-full font-thin text-left text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{ lineHeight: 2 }}
                  />
                  <p className="text-xs block mt-1 text-left">
                    {locationContent.length.toString().padStart(2, "0")}/150
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          {/* Carousel of Experience */}
          <div className="mt-20 -mr-3">
            <div className="grid grid-cols-1 md:grid-cols-[30%_65%] justify-between">
              <div>
                <h1
                  className="fontPD text-2xl md:text-3xl xl:text-4xl capitalize"
                  style={{
                    letterSpacing: "1px",
                    wordSpacing: "2px",
                    lineHeight: 1.5,
                  }}
                >
                  Be part of this <br className="hidden lg:block" /> Experience
                </h1>
              </div>

              <div>
                {/* goes to table "hotelInfo" as "expimghotel1.....to....expimghotel10"*/}
                <Carousel
                  ref={carouselRef}
                  responsive={responsive_TailoredExpCarousel}
                  autoPlay={false}
                  autoPlaySpeed={3000}
                  infinite
                  keyBoardControl
                  showDots={showDots}
                  customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
                  customRightArrow={<CustomRightArrowTailoredExpCarousel />}
                  beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
                >
                  {[...Array(MAX_CARDS_Exp)].map((_, index) => (
                    <div key={index} className="mx-3">
                      <div className="relative w-full h-[350px] border-2 border-dashed border-gray-400 overflow-hidden">
                        {tailoredExpData[index]?.img ? (
                          <>
                            <img
                              src={tailoredExpData[index].img}
                              alt="Img"
                              className="w-full h-full object-cover"
                            />
                            <div
                              onClick={() => {
                                const fieldName = `expimghotel${index + 1}`;
                                const img = tailoredExpData[index]?.img;
                                const isLocalOnly =
                                  !!img &&
                                  (img.startsWith("blob:") ||
                                    img.startsWith("data:"));
                                handleDeleteHotelImage(fieldName, {
                                  isLocalOnly,
                                  localClear: () => {
                                    const newData = [...tailoredExpData];
                                    newData[index] = {
                                      ...newData[index],
                                      img: null,
                                      file: null,
                                    };
                                    setTailoredExpData(newData);
                                  },
                                });
                              }}
                              className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                            >
                              <MdDelete size={18} />
                            </div>

                            <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                              <div className="flex gap-1 items-center">
                                Replace <FcAddImage size={20} />
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    const newData = [...tailoredExpData];
                                    newData[index].img =
                                      URL.createObjectURL(file); // preview
                                    newData[index].file = file; // actual File for backend
                                    setTailoredExpData(newData);
                                  }
                                }}
                                className="hidden"
                              />
                            </label>
                          </>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                            <FcAddImage size={50} />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const newData = [...tailoredExpData];
                                  newData[index].img =
                                    URL.createObjectURL(file);
                                  newData[index].file = file;
                                  setTailoredExpData(newData);
                                }
                              }}
                              className="hidden"
                            />
                          </label>
                        )}
                      </div>
                      {/* goes to table "hotelInfo" as "exptitlehotel1.....to....exptitlehotel10" */}
                      <input
                        type="text"
                        maxLength={50}
                        placeholder="Experience Title"
                        value={tailoredExpData[index]?.title || ""}
                        onChange={(e) => {
                          const newData = [...tailoredExpData];
                          newData[index].title = e.target.value;
                          setTailoredExpData(newData);
                        }}
                        className="w-full text-xl mt-5 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      />
                      <p className="text-xs block mt-1">
                        {(tailoredExpData[index]?.title?.length || 0)
                          .toString()
                          .padStart(2, "0")}
                        /50
                      </p>
                      <br />
                      {/* goes to table "hotelInfo" as "expconhotel1.....to....expconhotel10" */}
                      <div className="my-3">
                        <textarea
                          rows={2}
                          placeholder="Experience Content..."
                          maxLength={100}
                          value={tailoredExpData[index]?.content || ""}
                          onChange={(e) => {
                            const newData = [...tailoredExpData];
                            newData[index].content = e.target.value;
                            setTailoredExpData(newData);
                          }}
                          className="w-full text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                        />
                        <p className="text-xs block">
                          {(tailoredExpData[index]?.content?.length || 0)
                            .toString()
                            .padStart(2, "0")}
                          /100
                        </p>
                      </div>
                      {/* goes to table "hotelInfo" as "explinkhotel1.....to....explinkhotel10" */}
                      <input
                        type="text"
                        maxLength={255}
                        placeholder="PDF Drive link or URL"
                        value={tailoredExpData[index]?.link || ""}
                        onChange={(e) => {
                          const newData = [...tailoredExpData];
                          newData[index].link = e.target.value;
                          setTailoredExpData(newData);
                        }}
                        className="w-full text-sm mt-3 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      />
                      <p className="text-xs block mt-1">
                        {(tailoredExpData[index]?.link?.length || 0)
                          .toString()
                          .padStart(2, "0")}
                        /255
                      </p>
                    </div>
                  ))}
                </Carousel>

                <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
                  <FaChevronLeft
                    onClick={handlePrevSlide}
                    className="cursor-pointer"
                  />
                  Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
                  {TailoredExpCarousel.length}
                  <FaChevronRight
                    onClick={handleNextSlide}
                    className="cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Data not to be shown in website */}
          <div>
            <p className="text-lg text-center mb-8">
              Additional Required Data{" "}
              <i>(not to be displayed on the website)</i>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
              <div className="flex flex-col w-full">
                {/* goes to table properties as propertycode */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Code<sub className="text-red-500 text-base">*</sub>
                </label>
                <input
                  placeholder="Enter property code"
                  name="propertycode"
                  required
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                {/* goes to table properties as youtubelink */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property's Owner name
                </label>
                <input
                  placeholder="Enter Owner's name"
                  name="propertyowner"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Brochure
                </label>
                <input
                  placeholder="Enter Drive Link"
                  name="propertybrochure"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                {/* goes to table properties as currentprice */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Current Price
                </label>
                <input
                  placeholder="Enter current price"
                  name="currentprice"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as defaultprice */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Default Price
                </label>
                <input
                  placeholder="Enter default price"
                  name="defaultprice"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as deposit */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Security Deposit
                </label>
                <input
                  placeholder="Enter security deposit"
                  name="deposit"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxadult */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Adults
                </label>
                <input
                  placeholder="Enter max adults"
                  name="maxadult"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxchild */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Children
                </label>
                <input
                  placeholder="Enter max children"
                  name="maxchild"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxbed */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Bedroom
                </label>
                <input
                  placeholder="Enter max bedroom"
                  name="maxbed"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxbath */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Bathroom
                </label>
                <input
                  placeholder="Enter max bathroom"
                  name="maxbath"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maplink */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Map Location
                </label>
                <input
                  placeholder="Enter map location"
                  name="maplink"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as youtubelink */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Youtube Link
                </label>
                <input
                  placeholder="Enter youtube link"
                  name="youtubelink"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              {/* 
              <div className="relative w-full" ref={dropdownRef_dropdownExp}>
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Experience
                </label>

                <div
                  onClick={() => setIsOpen_dropdownExp((prev) => !prev)}
                  className="border border-gray-400 p-3 rounded-lg w-full cursor-pointer text-sm bg-[#F8F9FA] focus:outline-none"
                >
                  {selectedOptions_dropdownExp.length > 0
                    ? selectedOptions_dropdownExp.join(", ")
                    : "Select your experience(s)"}
                </div>

                {isOpen_dropdownExp && (
                  <div className="absolute top-full left-0 w-full bg-[#F8F9FA] border border-gray-300 mt-1 rounded-md shadow-md z-10">
                    {options_dropdownExp.map((option) => (
                      <label
                        key={option}
                        className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={selectedOptions_dropdownExp.includes(option)}
                          onChange={() => toggleOption_dropdownExp(option)}
                          className="accent-black"
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                )}
              </div> */}
              <div className="flex flex-col w-full">
                {/* goes to table properties as seasonType */}
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Season Type
                </label>

                <select
                  name="seasonType"
                  value={seasonType}
                  onChange={(e) => setSeasonType(e.target.value)}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select season type</option>
                  <option value="Summer">Summer</option>
                  <option value="Winter">Winter</option>
                  <option value="Monsoon">Monsoon</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as propertytype */}
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Property Type<sub className="text-red-500 text-base">*</sub>
                </label>

                <select
                  name="propertytype"
                  required
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="Hotel">Hotel</option>
                </select>
              </div>

              {/* Destination (State) */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Destination<sub className="text-red-500 text-base">*</sub>
                </label>
                <select
                  name="destination"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                  value={selectedState}
                  onChange={handleStateChange}
                >
                  <option value="">Select your destination</option>
                  {indiaStates.map((state) => (
                    <option key={state.id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Location (City) */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Select Location<sub className="text-red-500 text-base">*</sub>
                </label>
                <select
                  name="location"
                  value={locationCity}
                  onChange={(e) => setLocationCity(e.target.value)}
                  disabled={!selectedState || citiesLoading}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">
                    {citiesLoading
                      ? "Loading cities..."
                      : selectedState
                        ? "Select your location"
                        : "First select destination"}
                  </option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-10 w-72">
              <button
                onClick={() => navigate("/Properties")}
                className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleUpdateHotel}
                disabled={loading}
                className={`px-6 z-30 py-2 rounded-lg text-center text-white relative transition-all duration-700 text-sm ${
                  loading
                    ? "bg-green-700 cursor-not-allowed"
                    : "bg-green-900 hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700"
                }`}
                // className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
              >
                {/* Save */}
                {loading ? (
                  <div className="flex items-center justify-center space-x-2">
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    <span>Saving...</span>
                  </div>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditHotelElementor;
